import axios from 'axios';

const ariInterceptor = axios.create({
    baseUrl: process.env.REACT_APP_API_ARI,
});

const token = process.env.REACT_APP_KEYARI;

ariInterceptor.interceptors.request.use(
    (config) => {
            config.headers.Authorization = `Bearer ${token}`;            
        return config;
    },
    (error) => Promise.reject(error)
);

export default ariInterceptor;